import {
  Button,
  BUTTON_SIZE,
  BUTTON_VARIANT,
  Typography
} from '@sanlam-glacier/app-common/components';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import './Layout.scss';
import { GenericErrorIconLink } from '../../atoms/generic-error-icon-link/GenericErrorIconLink';
import { Theme } from 'components/atoms/theme/Theme';
import { useConfig } from 'providers/config/ConfigProvider';

export interface GenericErrorLayoutProps {
  image?: string;
  hideHomeButton?: boolean;
  title: string;
  subtitle: string;
  links?: GenericErrorLayoutLink[];
  buttons?: GenericErrorLayoutButton[];
}

export interface GenericErrorLayoutLink {
  icon?: string;
  title: string;
  path: string;
}

export interface GenericErrorLayoutButton {
  title: string;
  onClick: () => void;
}

export const Layout = ({
  image,
  hideHomeButton,
  title,
  subtitle,
  links,
  buttons
}: GenericErrorLayoutProps) => {
  const getErrorLinks = (): GenericErrorLayoutLink[] => {
    if (links && links.length > 0) {
      return [...links.slice(0, 2)];
    }
    return [];
  };

  const getErrorButtons = (): GenericErrorLayoutButton[] => {
    if (buttons && buttons.length > 0) {
      return [...buttons.slice(0, 2)];
    }
    return [];
  };

  const errorButtons = getErrorButtons();
  const errorLinks = getErrorLinks();
  const { theme } = useConfig();
  const { errorPage } = useGetBranding(theme);

  return (
    <div
      className={
        'base-error-layout-content-container-vertical-positioner ' + title.toLowerCase() + '-page'
      }
    >
      <div className='base-error-layout-content-container-horizontal-positioner'>
        <div className='base-error-layout-content-container'>
          <div className='base-error-layout-content'>
            {!(hideHomeButton ?? false) && (
              <GenericErrorIconLink title='Home' icon='action_home' path='/' />
            )}

            <Typography
              align={Typography.ALIGN.LEFT}
              variant={Typography.VARIANT.H1}
              className='generic-error-layout-title'
            >
              {title}
            </Typography>

            <Typography
              align={Typography.ALIGN.LEFT}
              weight={Typography.WEIGHT.NORMAL}
              variant={Typography.VARIANT.H4}
            >
              {subtitle}
            </Typography>

            {errorLinks && (
              <div className='generic-error-layout-link-container'>
                {errorLinks.map((errorLink, index) => (
                  <GenericErrorIconLink
                    title={errorLink.title}
                    icon={errorLink.icon}
                    path={errorLink.path}
                    key={`error-link-${index}`}
                  />
                ))}
              </div>
            )}

            {errorButtons && (
              <div className='generic-error-layout-button-container'>
                {errorButtons.map((errorButton, index) => (
                  <Theme variant='secondary' key={`error-button-${index}`}>
                    <Button
                      aria-label={errorButton.title}
                      onClick={errorButton.onClick}
                      size={BUTTON_SIZE.MEDIUM}
                      variant={index === 0 ? BUTTON_VARIANT.PRIMARY : BUTTON_VARIANT.SECONDARY}
                      className={
                        index === 0
                          ? 'generic-error-layout-button-primary'
                          : 'generic-error-layout-button-secondary'
                      }
                    >
                      {errorButton.title}
                    </Button>
                  </Theme>
                ))}
              </div>
            )}
          </div>
          <div className='base-error-layout-image-container-outer'>
            <div className='base-error-layout-image-container-inner'>
              <img
                alt='Glacier login'
                loading='lazy'
                className='base-error-layout-image'
                src={image ? image : errorPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
